import * as React from 'react';
import { cn } from './lib/utils';

// Domain and signal-state badge variants with NexoNurse color system
const VARIANT_CLASSES = {
  // Signal state variants
  'on-track':      'bg-green-bg text-green-nn border border-green-nn/25',
  'below-target':  'bg-yellow-bg text-yellow-nn border border-yellow-nn/25',
  'critical':      'bg-red-bg text-red-critical border border-red-critical/25',
  'watch':         'bg-yellow-bg text-yellow-nn border border-yellow-nn/25',
  'ok':            'bg-green-bg text-green-nn border border-green-nn/25',
  'info':          'bg-surface text-text-dark-secondary border border-nn-border',
  // Domain variants
  'staffing':      'bg-yellow-bg text-yellow-nn border border-yellow-nn/25',
  'quality':       'bg-[rgba(44,95,168,0.08)] text-royal border border-royal/25',
  'access':        'bg-[rgba(8,145,178,0.08)] text-aqua border border-aqua/25',
  'finance':       'bg-green-bg text-green-nn border border-green-nn/25',
  'consumer':      'bg-[rgba(224,124,62,0.08)] text-orange-warn border border-orange-warn/25',
  'health':        'bg-[rgba(10,123,143,0.08)] text-teal-dark border border-teal-dark/25',
};

const SIZE_CLASSES = {
  sm:      'px-1.5 py-0 text-[10px]',
  default: 'px-2 py-0.5 text-[11px]',
};

function StatusBadge({ variant = 'info', size = 'default', className, children, ...props }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded font-semibold leading-tight',
        VARIANT_CLASSES[variant] ?? VARIANT_CLASSES['info'],
        SIZE_CLASSES[size],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export { StatusBadge };
